import { gql } from '@apollo/client/core';

export const updateAddress = gql`
  mutation shippingAddressUpdate($input: AddressInput!, $sourceOrderId: String!) {
    shippingAddressUpdate(input: $input, sourceOrderId: $sourceOrderId)
  }
`;
